/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GroupActivity } from './GroupActivity';
import {
    GroupActivityFromJSON,
    GroupActivityFromJSONTyped,
    GroupActivityToJSON,
} from './GroupActivity';
import type { GroupMemberStatus } from './GroupMemberStatus';
import {
    GroupMemberStatusFromJSON,
    GroupMemberStatusFromJSONTyped,
    GroupMemberStatusToJSON,
} from './GroupMemberStatus';

/**
 * 
 * @export
 * @interface FocusGroupDetails
 */
export interface FocusGroupDetails {
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    portalDisplayText?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    onlineClassroomLink?: string;
    /**
     * 
     * @type {Date}
     * @memberof FocusGroupDetails
     */
    firstActivity?: Date;
    /**
     * 
     * @type {GroupMemberStatus}
     * @memberof FocusGroupDetails
     */
    groupMemberStatus?: GroupMemberStatus;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    groupTemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    locationId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FocusGroupDetails
     */
    locationIsOnline?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FocusGroupDetails
     */
    nextActivity?: Date;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    primaryCounsellorId?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    primaryCounsellorName?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    theme?: string;
    /**
     * 
     * @type {number}
     * @memberof FocusGroupDetails
     */
    availableSeats?: number;
    /**
     * 
     * @type {number}
     * @memberof FocusGroupDetails
     */
    currentNumberOfParticipants?: number;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    language?: string;
    /**
     * 
     * @type {number}
     * @memberof FocusGroupDetails
     */
    maxNumberOfParticipants?: number;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    primaryCounsellorEmail?: string;
    /**
     * 
     * @type {Date}
     * @memberof FocusGroupDetails
     */
    publishDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FocusGroupDetails
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof FocusGroupDetails
     */
    unPublishDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    locationStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    locationPostalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusGroupDetails
     */
    locationCity?: string;
    /**
     * 
     * @type {Array<GroupActivity>}
     * @memberof FocusGroupDetails
     */
    groupActivities?: Array<GroupActivity>;
}

/**
 * Check if a given object implements the FocusGroupDetails interface.
 */
export function instanceOfFocusGroupDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FocusGroupDetailsFromJSON(json: any): FocusGroupDetails {
    return FocusGroupDetailsFromJSONTyped(json, false);
}

export function FocusGroupDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FocusGroupDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'portalDisplayText': !exists(json, 'PortalDisplayText') ? undefined : json['PortalDisplayText'],
        'onlineClassroomLink': !exists(json, 'OnlineClassroomLink') ? undefined : json['OnlineClassroomLink'],
        'firstActivity': !exists(json, 'FirstActivity') ? undefined : (new Date(json['FirstActivity'])),
        'groupMemberStatus': !exists(json, 'GroupMemberStatus') ? undefined : GroupMemberStatusFromJSON(json['GroupMemberStatus']),
        'groupTemplate': !exists(json, 'GroupTemplate') ? undefined : json['GroupTemplate'],
        'locationName': !exists(json, 'LocationName') ? undefined : json['LocationName'],
        'locationId': !exists(json, 'LocationId') ? undefined : json['LocationId'],
        'locationIsOnline': !exists(json, 'LocationIsOnline') ? undefined : json['LocationIsOnline'],
        'nextActivity': !exists(json, 'NextActivity') ? undefined : (new Date(json['NextActivity'])),
        'primaryCounsellorId': !exists(json, 'PrimaryCounsellorId') ? undefined : json['PrimaryCounsellorId'],
        'primaryCounsellorName': !exists(json, 'PrimaryCounsellorName') ? undefined : json['PrimaryCounsellorName'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'theme': !exists(json, 'Theme') ? undefined : json['Theme'],
        'availableSeats': !exists(json, 'AvailableSeats') ? undefined : json['AvailableSeats'],
        'currentNumberOfParticipants': !exists(json, 'CurrentNumberOfParticipants') ? undefined : json['CurrentNumberOfParticipants'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'language': !exists(json, 'Language') ? undefined : json['Language'],
        'maxNumberOfParticipants': !exists(json, 'MaxNumberOfParticipants') ? undefined : json['MaxNumberOfParticipants'],
        'primaryCounsellorEmail': !exists(json, 'PrimaryCounsellorEmail') ? undefined : json['PrimaryCounsellorEmail'],
        'publishDate': !exists(json, 'PublishDate') ? undefined : (new Date(json['PublishDate'])),
        'requiresApproval': !exists(json, 'RequiresApproval') ? undefined : json['RequiresApproval'],
        'unPublishDate': !exists(json, 'UnPublishDate') ? undefined : (new Date(json['UnPublishDate'])),
        'locationStreet': !exists(json, 'LocationStreet') ? undefined : json['LocationStreet'],
        'locationPostalCode': !exists(json, 'LocationPostalCode') ? undefined : json['LocationPostalCode'],
        'locationCity': !exists(json, 'LocationCity') ? undefined : json['LocationCity'],
        'groupActivities': !exists(json, 'GroupActivities') ? undefined : ((json['GroupActivities'] as Array<any>).map(GroupActivityFromJSON)),
    };
}

export function FocusGroupDetailsToJSON(value?: FocusGroupDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Name': value.name,
        'PortalDisplayText': value.portalDisplayText,
        'OnlineClassroomLink': value.onlineClassroomLink,
        'FirstActivity': value.firstActivity === undefined ? undefined : (value.firstActivity.toISOString()),
        'GroupMemberStatus': GroupMemberStatusToJSON(value.groupMemberStatus),
        'GroupTemplate': value.groupTemplate,
        'LocationName': value.locationName,
        'LocationId': value.locationId,
        'LocationIsOnline': value.locationIsOnline,
        'NextActivity': value.nextActivity === undefined ? undefined : (value.nextActivity.toISOString()),
        'PrimaryCounsellorId': value.primaryCounsellorId,
        'PrimaryCounsellorName': value.primaryCounsellorName,
        'Status': value.status,
        'Theme': value.theme,
        'AvailableSeats': value.availableSeats,
        'CurrentNumberOfParticipants': value.currentNumberOfParticipants,
        'Description': value.description,
        'Language': value.language,
        'MaxNumberOfParticipants': value.maxNumberOfParticipants,
        'PrimaryCounsellorEmail': value.primaryCounsellorEmail,
        'PublishDate': value.publishDate === undefined ? undefined : (value.publishDate.toISOString()),
        'RequiresApproval': value.requiresApproval,
        'UnPublishDate': value.unPublishDate === undefined ? undefined : (value.unPublishDate.toISOString()),
        'LocationStreet': value.locationStreet,
        'LocationPostalCode': value.locationPostalCode,
        'LocationCity': value.locationCity,
        'GroupActivities': value.groupActivities === undefined ? undefined : ((value.groupActivities as Array<any>).map(GroupActivityToJSON)),
    };
}

